import { BreakableText } from "./BreakableText.tsx";

export function BreakableEmail({ email }: { email: string }) {
  const atIndex = email.indexOf("@");
  if (atIndex <= 0) return <BreakableText>{email}</BreakableText>;
  return (
    <BreakableText>
      {email.slice(0, atIndex)}
      <wbr />
      {email.slice(atIndex)}
    </BreakableText>
  );
}
